import React from 'react';
import Table from 'react-bootstrap/Table';
import DriverNames from '../assignedUser/DriverNames';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
//import Swal from '../../../node_modules/sweetalert2/dist/sweetalert2';
import Swal from '../../messageBox/customSweetAlert';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import { DELETE_PASSENGER } from '../../constant';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../../redux/loaderAction';
import { Base64 } from 'js-base64';
import { dateFormat } from '../../utils';
import { Avatar } from '@mui/material';

function PassengerTable({ tableData, setIsReload }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleEditClick = (id) => {
    navigate(`/home/passenger/edit/${id}`);
  }


  const handleDeleteClick = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this item!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(setLoading(true));
        axios.delete(DELETE_PASSENGER + '/' + `${id}`)
          .then((response) => {
            if (response.data.status === 200) {
              dispatch(setLoading(false));
              //toast.success(response.data.message, { position: "top-center" });
              Swal.fire({
                title: 'Success!',
                text: response.data.message,
                icon: 'success',
                confirmButtonText: 'OK',
              });
              setIsReload(prev => !prev);
            } else {
              //toast.error(response.data.message, { position: "top-center" });
              dispatch(setLoading(false));
              Swal.fire({
                title: 'warning!',
                text: response.data.message,
                icon: 'warning',
                confirmButtonText: 'OK',
              });

            }
            //console.log(response);
          }).catch(error => {
            dispatch(setLoading(false));
            toast.error(error, { position: "top-center" });
          })
        //alert(userId);


      }
    });
  }
  return (
    <>
      <div>
        <ToastContainer />
      </div>
      <Table striped bordered hover className='tbl-require'>
        <thead>
          <tr>
            <th><b>Passenger Name</b></th>
            <th><b>First Name</b></th>
            <th><b>Last Name</b></th>
            <th><b>Payor</b></th>
            <th><b>Member ID/Insurance Number</b></th>
            <th><b>Phone No.</b></th>
            <th><b>Last Trip Completed</b></th>
            <th><b>Visit Frequency</b></th>
            <th style={{ textAlign: 'center' }}><b>Action</b></th>
          </tr>
        </thead>
        <tbody>
          {tableData && tableData.length > 0 ? (
            tableData.map((details, index) => (
              <tr key={details?.passenger_id}>
                <td>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Avatar alt={details?.user?.first_name + ' ' + details?.user?.last_name} style={{ marginRight: '10px' }} />
                    <a href={`/home/passenger/profile/id?profilId=${Base64.encode(details?.passenger_id)}`} // Replace with the correct route
                      target="_blank" // Open in a new tab
                      onClick={() => localStorage.setItem('activeMenu', 'Passenger List')}
                      rel="noopener noreferrer" // Security best practice
                      style={{ textDecoration: 'none', color: 'rgb(49, 135, 111)' }} // Inherit color and remove underline
                    >
                      {`${details?.user?.first_name} ${details?.user?.middle_name} ${details?.user?.last_name}`}
                    </a>
                  </div>


                  {/* {details.passenger_name} */}
                </td>
                <td>{details?.user?.first_name}</td>
                <td>{details?.user?.last_name}</td>
                <td>{details?.payerDetails?.payer_name}</td>
                <td>{details?.pass_pmi_no}</td>
                <td>{details?.pass_cell_phn}</td>
                {/* <td>{details?.user_email }</td> */}
                <td>{dateFormat(details?.trip_date)}</td>
                {/* <td>{details.passenger_address}</td>  */}
                <td>{details?.visit_frequency && details?.visit_frequency === 1 ? 'Recurring' : (details?.visit_frequency === 2 ? 'One Time' : '')} </td>

                {/* <td>{details.pass_pmi_no}</td> */}
                <td style={{ textAlign: 'center', cursor: 'pointer' }}>
                  <i className="pi pi-pen-to-square icon-btn-edit" onClick={() => handleEditClick(details?.passenger_id)}></i>
                  <i className="pi pi-trash icon-btn-delete" onClick={() => handleDeleteClick(details?.passenger_id)}></i>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="10" style={{ textAlign: 'center' }}>No records found</td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  )
}

export default PassengerTable